<template>
	<v-card class="detail-view col">
		<v-app-bar flat color="rgba(0, 0, 0, 0)" class="mb-10">
			<v-row style="align-items: center">
				<div>
					<v-card-title>{{ slide.title }}</v-card-title>
					<v-card-subtitle style="flex-direction: row; display: flex"
						><p style="margin-right: 20px !important">
							{{ slide.type }}
						</p>
						<p style="margin-right:20px !important">|</p>
						<p>
							{{ slide.width }} x {{ slide.height }} px
						</p></v-card-subtitle
					>
				</div>
				<span
					@click="clickCanva"
					class="canva-btn canva-btn-theme-default canva-btn-size-m ml-5"
					v-if="slide.canva_url"
				>
					<span class="canva-btn-i"></span>
					Design with Canva
				</span>
				<Roundup-Button
					@click="downloadFile(slide.url)"
					:color="slide.canva_url ? 'white' : 'primary'"
					class="ml-5"
					>Download</Roundup-Button
				>
			</v-row>
			<v-spacer></v-spacer>
			<v-btn small fab @click="$emit('close')" elevation="0" plain
				><v-icon small>fas fa-times</v-icon></v-btn
			>
		</v-app-bar>
		<v-card-text>
			<div class="detail-view-body row">
				<div class="detail-view-image-container">
					<img
						class="detail-view-image"
						:src="slide.url"
						:alt="slide.type"
						:class="formatTypeWithHyphens(slide.type)"
					/>
				</div>
				<div class="detail-view-details">
					<div class="suggested-text">
						<div class="suggested-text-title row">
							<p style="margin-right: 10px !important">
								Suggested Text
							</p>
							<i
								@click="copyToken($refs.text.innerText)"
								class=" fas fa-copy"
								:style="{
									cursor: 'pointer',
									marginRight: '20px'
								}"
							></i>
							<p v-if="copied" style="color: green">Copied!</p>
						</div>
						<div class="suggested-text-info" ref="text"></div>
					</div>
					<div class="pro-tips" v-if="slide.pro_tip_1">
						<div class="pro-tips-title">
							<p>Pro Tips</p>
						</div>
						<div class="pro-tips-info">
							<ul>
								<li v-if="slide.pro_tip_1">
									<p>{{ slide.pro_tip_1 }}</p>
								</li>
								<li v-if="slide.pro_tip_2">
									<p>{{ slide.pro_tip_2 }}</p>
								</li>
								<li v-if="slide.pro_tip_3">
									<p>{{ slide.pro_tip_3 }}</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div
				class="detail-view-footer"
				v-if="slide.examples && slide.examples.length > 0"
			>
				<p style="margin: 20px 0px">Examples</p>
				<div class="examples">
					<div v-for="ex in slide.examples" v-bind:key="ex.id">
						<div class="example">
							<img
								class="examples-image"
								:src="ex.url"
								:class="formatTypeWithHyphens(slide.type)"
								@click="downloadFile(ex.url)"
							/>

							<p
								:style="{
									fontWeight: 'bold',
									fontSize: '14px'
								}"
							>
								{{ ex.title }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex'
import UiButton from '../../ui/Button'
import { formatStrWithHyphens } from '../../../utilities'
import { analytics } from '../../../utilities/tracker'

export default {
	components: {
		UiButton
	},
	name: 'lib-detail-view',
	props: ['slide', 'institution', 'url'],
	data() {
		return {
			copied: false,
			copyMessage: 'Copied!'
		}
	},
	methods: {
		...mapActions(['getLibraryImage']),

		downloadFile(url) {
			if (window.analytics) {
				window.analytics.track('marketing_library_download', {
					title: this.slide.title,
					type: this.slide.type,
					url: url.replace(
						'https://admin-marketing-library.s3.amazonaws.com/',
						''
					),
					image: true
				})
			}
			this.getLibraryImage(url)
		},
		async copyToken(value) {
			if (!navigator.clipboard) {
				// Clipboard API not available
				return
			}
			try {
				await navigator.clipboard.writeText(value)
				this.copied = true
				setTimeout(() => {
					this.copied = false
				}, 1000)
			} catch (err) {
				console.error('Failed to copy!', err)
			}
		},
		formatTypeWithHyphens(t) {
			return formatStrWithHyphens(t)
		},
		formatSuggestedText(text) {
			try {
				text = text.replaceAll(
					'{ORGANIZATION NAME}',
					this.institution.name || 'our organization'
				)

				var mission = 'make a difference'

				if (this.institution.impact_statement) {
					mission = this.institution.impact_statement.toLowerCase()
				}

				text = text.replaceAll('{ORGANIZATION MISSION}', mission)

				text = text.replaceAll(
					'{CUSTOM REGISTRATION URL}',
					`<a target="_blank" href="${this.url}">${this.url}</a>`
				)
			} catch (e) {
				console.log(e)
			}

			return text
		},
		clickCanva() {
			analytics.track('canva_clicked', {
				title: this.slide.title,
				type: this.slide.type,
				url: this.slide.canva_url
			})
			window.open(this.slide.canva_url, '_blank')
		}
	},
	watch: {
		slide() {
			this.$nextTick(() => {
				let div = this.$refs.text
				let text = this.formatSuggestedText(this.slide.suggested_text)

				text = text.split('  ')

				if (text.length === 1) {
					div.innerHTML = `<p>${text}</p>`
				}
				let newText = ''
				for (var sent of text) {
					newText += sent + '\n\n'
				}
				div.innerHTML = `<p>${newText}</p>`
			})
		}
	},
	mounted() {
		try {
			let div = this.$refs.text
			let text = this.formatSuggestedText(this.slide.suggested_text)

			text = text.split('  ')

			if (text.length === 1) {
				div.innerHTML = `<p>${text}</p>`
			}
			let newText = ''
			for (var sent of text) {
				newText += sent + '\n\n'
			}
			div.innerHTML = `<p>${newText}</p>`
		} catch (e) {
			this.setAlert({
				alertText: 'Error loading details',
				showAlert: true,
				alertColor: 'error'
			})
		}

		if (window.analytics) {
			window.analytics.track('marketing_library_details', {
				title: this.slide.title,
				type: this.slide.type,
				url: this.slide.url.replace(
					'https://admin-marketing-library.s3.amazonaws.com/',
					''
				),
				image: true
			})
		}
	}
}
</script>

<style lang="scss">
@import '../../../styles/variables';
.detail-view {
	width: 100%;
	color: $roundup-charcoal !important;
}
.detail-view-title {
	.title {
		font-size: 24px;
		color: $roundup-charcoal !important;
	}
}
.detail-view-header {
	height: 100%;
}
.detail-view-body {
	justify-content: center;
}
.detail-view-details {
	display: flex;
	flex-direction: column;
	flex: 1;
	justify-content: flex-start;
	.suggested-text-title {
		margin: 0 0 0 0;
		align-items: center;
		width: 100%;
		color: $roundup-charcoal !important;
		p {
			margin-right: 10px;
			font-weight: $font-medium;
			line-height: 1em;
			color: $roundup-charcoal !important;
		}
	}
	.suggested-text-info {
		margin-top: 10px;
		color: $roundup-charcoal !important;
		p {
			white-space: pre-line;
			max-width: 100%;
			word-wrap: break-word;
			color: $roundup-charcoal !important;
		}
	}
	.pro-tips {
		margin-top: 20px;
	}
	.pro-tips-title {
		p {
			font-weight: $font-medium;
			color: $roundup-charcoal !important;
		}
	}
	.fa-copy {
		font-weight: 100;
		height: 15px;
	}
}
.detail-view-button {
	margin-bottom: 30px;
	.roundup-button {
		margin: 0;
	}
}
.detail-view-image-container {
	display: flex;
	flex: 1;
	margin-bottom: 40px;
	flex-direction: row;
	margin-right: 30px;
}
.detail-view-image,
.detail-view .facebook-posts,
.detail-view .instagram-posts,
.detail-view .twitter-posts,
.detail-view .emails {
	max-height: 400px;
	max-width: 800px;
}
.detail-view-footer {
	.examples {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		.example {
			margin-right: 20px;
			margin-bottom: 20px;
			cursor: pointer;
		}
	}
}
.detail-view-footer .examples .facebook-posts,
.detail-view-footer .examples .instagram-posts,
.detail-view-footer .examples .twitter-posts,
.detail-view-footer .examples .emails {
	max-height: 150px;
}
.col {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.canva-btn-theme-default {
	background-color: #7d2ae8;
	color: #ffffff;
}

.canva-btn-theme-default:hover,
.canva-btn-theme-default:focus {
	background-color: #8d39fa;
}

.canva-btn-theme-default:active {
	background-color: #6718cf;
}

.canva-btn {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-smooth: always;
	font-family: 'Open Sans', sans-serif;
	font-weight: 600;
	color: white !important;
	text-decoration: none !important;
	line-height: 1.6;
	box-sizing: border-box;
	user-select: none;
	cursor: pointer;
	border: 1px solid transparent;
	max-width: 100%;
	min-width: 80px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	white-space: nowrap;
	transition: background-color 0.1s linear;
	box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
		0 1px 5px 0 rgb(0 0 0 / 12%);
}

.canva-btn-size-m {
	height: 40px;
	border-radius: 4px;
	font-size: 14px;
	padding-right: 16px;
}

.canva-btn-size-m .canva-btn-i {
	width: 24px;
	height: 24px;
	margin: 0 9px;
}

.canva-btn-i {
	background-size: contain;
}

.canva-btn-theme-default .canva-btn-i {
	filter: drop-shadow(3px 3px 4px rgba(0, 0, 0, 0.1));
	background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='12' cy='12' r='12' fill='%235A32FA'/%3e%3ccircle cx='12' cy='12' r='12' fill='url(%23paint0_radial)'/%3e%3ccircle cx='12' cy='12' r='12' fill='url(%23paint1_radial)'/%3e%3ccircle cx='12' cy='12' r='12' fill='url(%23paint2_radial)'/%3e%3ccircle cx='12' cy='12' r='12' fill='url(%23paint3_radial)'/%3e%3cpath d='M17.1807 14.4617C17.0816 14.4617 16.9945 14.5452 16.9038 14.7279C15.8797 16.8047 14.1108 18.2741 12.0637 18.2741C9.69682 18.2741 8.23108 16.1375 8.23108 13.1857C8.23108 8.18574 11.0169 5.29483 13.4638 5.29483C14.6073 5.29483 15.3056 6.01338 15.3056 7.15685C15.3056 8.51398 14.5345 9.23252 14.5345 9.71116C14.5345 9.92601 14.6682 10.0561 14.9332 10.0561C15.9979 10.0561 17.2476 8.83267 17.2476 7.10433C17.2476 5.42851 15.789 4.19672 13.3421 4.19672C9.29816 4.19672 5.70422 7.94582 5.70422 13.1332C5.70422 17.1485 7.99713 19.8019 11.535 19.8019C15.29 19.8019 17.4612 16.0659 17.4612 14.8532C17.4612 14.5846 17.3239 14.4617 17.1807 14.4617Z' fill='white'/%3e%3cdefs%3e%3cradialGradient id='paint0_radial' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(4.63579 21.2716) rotate(-49.4156) scale(18.5619)'%3e%3cstop stop-color='%235A32FA'/%3e%3cstop offset='1' stop-color='%235A32FA' stop-opacity='0'/%3e%3c/radialGradient%3e%3cradialGradient id='paint1_radial' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(6.35368 2.72842) rotate(54.7035) scale(20.9321)'%3e%3cstop stop-color='%2300C4CC'/%3e%3cstop offset='1' stop-color='%2300C4CC' stop-opacity='0'/%3e%3c/radialGradient%3e%3cradialGradient id='paint2_radial' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(4.63579 21.2716) rotate(-45.1954) scale(18.3372 8.43355)'%3e%3cstop stop-color='%235A32FA'/%3e%3cstop offset='1' stop-color='%235A32FA' stop-opacity='0'/%3e%3c/radialGradient%3e%3cradialGradient id='paint3_radial' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(7 3) rotate(62.4472) scale(25.9422 43.459)'%3e%3cstop stop-color='%2300C4CC' stop-opacity='0.725916'/%3e%3cstop offset='0.0001' stop-color='%2300C4CC'/%3e%3cstop offset='1' stop-color='%2300C4CC' stop-opacity='0'/%3e%3c/radialGradient%3e%3c/defs%3e%3c/svg%3e ");
}
</style>
